import { positionHoverEl } from '../utils/position-hover-el';
import { throttle } from '../utils/throttle';

/**
 * Apply tool-tips to external links
 */
class ExternalLink {
  constructor(el) {
    // Check if the device can hover
    const canHover = window.matchMedia?.('(hover: hover)').matches;
    if (!canHover) return;

    this.link = el;
    this.tooltip = null;

    // The link container (if any) to constrain tooltip within.
    // The js-link-container class is applied to main content and table blocks.
    this.linkContainer = this.link.closest('.js-link-container');

    this.applyAttrs();
    this.bindEvents();
  }

  /**
   * Apply necessary attributes to external links
   */
  applyAttrs() {
    this.link.classList.add('has-tool-tip');
    this.link.target = '_blank';
    this.link.rel = 'noopener noreferrer';
    this.createToolTip();
  }

  /**
   * Create tooltip element
   */
  createToolTip() {
    this.tooltip = document.createElement('span');
    this.tooltip.textContent = this.link.hostname;
    this.tooltip.setAttribute('role', 'tooltip');
    this.tooltip.classList.add('tool-tip');
    this.link.append(this.tooltip);
  }

  /**
   * Bind mousemove event to position tooltip
   */
  bindEvents() {
    // reduce frequency of position updates
    const throttledPosition = throttle((e) => {
      positionHoverEl(e, this.tooltip, this.link, this.linkContainer);
    }, 10);

    this.link.addEventListener('mousemove', throttledPosition);
  }
}

/**
 * Find and create tool-tips for all external links within a given element
 */
class CreateExternalLinks {
  constructor(el) {
    this.links = el.querySelectorAll('a');
    this.links.forEach((link) => {
      if (link.hostname && window.location.hostname !== link.hostname) {
        new ExternalLink(link);
      }
    });
  }
}

export default CreateExternalLinks;
